import React, { useEffect, useRef, useState } from "react";
import ProgressBar from "react-customizable-progressbar";
import runninggirl from "../../assets/images/gym/running.png";
import BaseImage from "../../assets/images/dasboard/base.webp";
import fastinginprogressbg from "../../assets/images/dasboard/fastinginprogressbg.png";
import fastinginprogressbg1 from "../../assets/images/dasboard/fastinginprogressbg1.png";
import stopBase from "../../assets/images/dasboard/StopBase.png";
import alarm from "../../assets/images/dasboard/alarm.png";
import { Link } from "react-router-dom";

const GymView = ({ workoutChoosedData }) => {
  const videoRef = useRef();
  const [playStatus, setPlayStatus] = useState("start");
  const [currentTime, setCurrentTime] = useState({ minutes: 0, seconds: 0 });
  const [playedPercentage, setPlayedPercentage] = useState(0);

  const [progress, setProgress] = useState({
    start: 0,
    playing: 0,
    stoped: 100,
  });

  const playVideo = () => {
    videoRef.current.play();
    setPlayStatus("playing");
  };

  const pauseVideo = () => {
    videoRef.current.pause();
    setPlayStatus("puased");
  };

  const stopVideo = () => {
    videoRef.current.pause();
    videoRef.current.currentTime = 0;
    setPlayStatus("stoped");
    setCurrentTime(0);
  };

  const updateCurrentTime = () => {
    if (videoRef.current) {
      const totalSeconds = Math.floor(videoRef.current.currentTime);
      const min = Math.floor(totalSeconds / 60);
      const sec = totalSeconds % 60;

      // setProgress({ ...progress, playing: sec });
      setCurrentTime({ minutes: min, seconds: sec });
    }
  };
  const handleTimeUpdate = () => {
    if (videoRef.current) {
      const currentTime = videoRef.current.currentTime;
      const duration = videoRef.current.duration;
      const percentage = (currentTime / duration) * 100;
      // setPlayedPercentage(percentage);
      setProgress({ ...progress, playing: percentage });
      // console.log(duration/60);
    }
  };

  useEffect(() => {
    videoRef.current?.load();

    const intervalId = setInterval(updateCurrentTime, 1000);

    // Clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [workoutChoosedData?.SourceUrl]);

  if (workoutChoosedData !== null) {
    return (
      <div className="m-[-20px]">
        <div className="relative">
          <video {...playStatus} ref={videoRef} onTimeUpdate={handleTimeUpdate}>
            <source src={workoutChoosedData.SourceUrl}></source>
          </video>
        </div>
        <br />
        <div className="">
          {playStatus === "start" ? (
            <>
              <div className="circleplayer">
                <div
                  className="circleplayer1 cursor-pointer"
                  onClick={() => {
                    playVideo();
                  }}
                >
                  <ProgressBar
                    strokeWidth={28}
                    strokeColor="#FF9950"
                    strokeLinecap="round"
                    trackStrokeWidth={8}
                    className="circleplayer2 z-20"
                    radius={100}
                    progress={progress.start}
                    cut={180}
                    rotate={-180}
                  ></ProgressBar>
                  <div className="circleplayer3 cursor-pointer z-10">
                    <Link to="/fastingdesh">
                      <div className="palyerdes">
                        <i
                          className="fa fa-play"
                          aria-hidden="true"
                          style={{
                            color: "#fff",
                          }}
                        ></i>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="desbase mb-5">
                <img
                  loading="lazy"
                  src={BaseImage}
                  alt="no-food"
                  className="deshimg opacity-25"
                />
              </div>
              <div className="grid place-items-center">
                <div className="border border-[#d3d3d3]	 px-5 py-2 leading-5 rounded font-medium text-black">
                  <div className="flex gap-2 place-items-center ">
                    <img src={alarm} /> {workoutChoosedData.duration} minutes
                  </div>
                </div>
                <h1 className="mt-10 font-bold text-lg text-capitalize">
                  {workoutChoosedData.name}
                </h1>
                <div
                  dangerouslySetInnerHTML={{
                    __html: workoutChoosedData.description,
                  }}
                  className="text-[#d3d3d3]"
                ></div>
                <div className="flex gap-5 mt-5">
                  <div>
                    <b className="text-7xl"> {currentTime.minutes}</b>
                    <small>m</small>
                  </div>
                  <div className="text-7xl">:</div>
                  <div>
                    <b className="text-7xl"> {currentTime.seconds}</b>
                    <small>s</small>
                  </div>
                </div>
              </div>
            </>
          ) : playStatus === "playing" ? (
            <>
              <div className="circleplayer">
                <div
                  className="circleplayer1 circleLayerPause1 cursor-pointer"
                  onClick={() => {
                    setPlayStatus("stoped");
                    pauseVideo();
                  }}
                >
                  <ProgressBar
                    strokeWidth={28}
                    strokeColor="#28F1C1"
                    strokeLinecap="round"
                    trackStrokeWidth={8}
                    className="circleplayer2 z-20"
                    // cut={180}
                    // rotate={-180}
                    radius={100}
                    progress={progress.playing}
                  ></ProgressBar>
                  <div className="circleplayer3  circleLayerPause3 cursor-pointer z-10">
                    <Link to="/fastingdesh">
                      <div className="palyerdes pauseInProgress">
                        <i
                          className="fa fa-pause"
                          aria-hidden="true"
                          style={{
                            color: "#fff",
                          }}
                        ></i>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>

              <div
                className="desbase mb-5"
                style={{
                  backgroundImage: "url(" + fastinginprogressbg1 + ")",
                  marginTop: "-210px",
                  height: "193px",
                }}
              >
                <img
                  loading="lazy"
                  src={fastinginprogressbg}
                  alt="no-food"
                  className="deshimg opacity-25"
                />
              </div>
              <div className="grid place-items-center">
                <div className="border border-[#d3d3d3]	 px-5 py-2 leading-5 rounded font-medium text-black">
                  <div className="flex gap-2 place-items-center ">
                    <img src={alarm} /> {workoutChoosedData.duration} minutes
                  </div>
                </div>
                <h1 className="mt-10 font-bold text-lg text-capitalize">
                  {workoutChoosedData.name}
                </h1>
                <div
                  dangerouslySetInnerHTML={{
                    __html: workoutChoosedData.description,
                  }}
                  className="text-[#d3d3d3]"
                ></div>
                <div className="flex gap-5 mt-5">
                  <div>
                    <b className="text-7xl"> {currentTime.minutes}</b>
                    <small>m</small>
                  </div>
                  <div className="text-7xl">:</div>
                  <div>
                    <b className="text-7xl"> {currentTime.seconds}</b>
                    <small>s</small>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="circleplayer">
                <div
                  className="circleplayer1 cursor-pointer"
                  onClick={() => {
                    playVideo();
                  }}
                >
                  <ProgressBar
                    strokeWidth={28}
                    strokeColor="#FF5050"
                    strokeLinecap="round"
                    trackStrokeWidth={8}
                    className="circleplayer2 z-20"
                    radius={100}
                    progress={progress.stoped}
                    cut={180}
                    rotate={-180}
                  ></ProgressBar>
                  <div className="circleplayer3 circleLayerPause5 cursor-pointer z-10">
                    <Link to="/fastingdesh">
                      <div className="palyerdes stopedProgress">
                        <i
                          className="fa fa-play"
                          aria-hidden="true"
                          style={{
                            color: "#fff",
                          }}
                        ></i>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
              <div
                className="desbase mb-5"
                style={{
                  backgroundImage: "url(" + stopBase + ")",
                  marginTop: "-210px",
                  height: "193px",
                }}
              >
                <img
                  loading="lazy"
                  src={stopBase}
                  alt="no-food"
                  className="deshimg opacity-25"
                />
              </div>
              <div className="grid place-items-center">
                <div className="border border-[#d3d3d3]	 px-5 py-2 leading-5 rounded font-medium text-black">
                  <div className="flex gap-2 place-items-center ">
                    <img src={alarm} /> {workoutChoosedData.duration} minutes
                  </div>
                </div>
                <h1 className="mt-10 font-bold text-lg text-capitalize">
                  {workoutChoosedData.name}
                </h1>
                <div
                  dangerouslySetInnerHTML={{
                    __html: workoutChoosedData.description,
                  }}
                  className="text-[#d3d3d3]"
                ></div>
                <div className="flex gap-5 mt-5">
                  <div>
                    <b className="text-7xl"> {currentTime.minutes}</b>
                    <small>m</small>
                  </div>
                  <div className="text-7xl">:</div>
                  <div>
                    <b className="text-7xl"> {currentTime.seconds}</b>
                    <small>s</small>
                  </div>
                </div>
              </div>
            </>
          )}
          {/* {console.log(workoutChoosedData)} */}
        </div>
      </div>
    );
  }
};

export default GymView;
